<template>
  <div class="select_lang-icas">
    <span class="lang_icon">
      <img v-if="isIscoTheme" class="lang_pic" src="@/assets/login_images/lang_black.svg" alt="">
      <img v-else-if="isLogin" class="lang_pic" src="@/assets/login_images/language.png" alt="">
      <img v-else class="lang_pic" src="@/assets/common/language.png" alt="">
    </span>
    <el-dropdown class="drop" :class="{'gray':isLogin,'white':!isLogin}" @command="handleSetLanguage">
      <span class="el-dropdown-link">
        {{ langName }}
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="item in siteConfig.langs"
          :key="item.lang"
          :command="item.lang"
          :disabled="language === item.lang"
        >
          {{ item.langName }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import getPageTitle from '@/utils/get-page-title'
import { mapGetters, mapActions } from 'vuex'
import { replaceParamVal, getUrlKey } from '@/utils'
import { isOS } from '../../utils/constant'
export default {
  // 登录页语言切换
  name: 'LangSelectIcon',
  props: {
    isLogin: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['language', 'langName', 'siteConfig', 'siteCode', 'system_source', 'uiConfig']),
    isIscoTheme() {
      return ['ISCO', 'ISCO-OS', 'SCS-CCS-CORE-US'].includes(this.system_source)
    },
  },
  watch: {
    language: {
      handler: function(n, o) {
        if (this.uiConfig.sfTheme && isOS()) {
          document.title = this.$t('__origin__.settings.title')
        } else {
          document.title = getPageTitle(this.$route.meta.title)
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions({
      setLanguage: 'site/setLanguage',
      setSiteConfig: 'site/siteConfig',
      setSiteList: 'site/siteList',
      setMobileCountries: 'public/mobileCountries',
      setAppLoading: 'app/setAppLoading'
    }),
    // 语言切换
    handleSetLanguage(langCode) {
      this.setAppLoading(true)
      // 前端国际化
      this.$i18n.locale = langCode
      // 更新语言
      this.setLanguage(langCode)
      // 若url上有lang，切换语言同步修改url上的lang的值
      if (getUrlKey('sysCode') || getUrlKey('lang')) {
        replaceParamVal('lang', langCode)
      }
      // 更新全量国家区号列表
      this.setMobileCountries({ siteCountryCode: this.siteConfig.country })
      // 更新站点列表
      this.setSiteList(this.siteConfig.country)
      // 更新站点配置
      this.setSiteConfig({ country: this.siteCode })
      this.$message({
        message: this.$t('message.switchLanguage'),
        type: 'success'
      })
      setTimeout(() => {
        window.location.reload()
      }, 1000)
      this.$track({ sceneType: 'Login', eventType: 'Select_Language', message: langCode })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';
  .select_lang-icas {
    cursor: pointer;
    .lang_icon {
      margin-right: 2px;
      >img{
        display: inline-block;
        vertical-align: middle;
        width: 16px;
        height: 16px;
      }
    }
    .drop {
      display: inline-block;
      vertical-align: middle;
    }
    .gray{
      color: $color02;
    }
    .white{
      color: $color01;
    }
  }

</style>
